<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
/**
 * Basic-table component
 */
export default {
  components: {ErrorMessage, Layout, PageHeader },
  data() {
    return {
      title: "White Label Agent List",
      items: [
        {
          text: "Agent",
          href: "/",
        },
        {
          text: "White Label Agent List",
          active: true,
        },
      ],
      agents: [],
        agent:[],
        agency:[],
        user:[],
        errors:null,
        visible:false,
        message:"",
        search:"",
        search_uname:"",
        search_fname:"",
        search_email:"",
        search_key:""

    };
  },
  mounted() {
    this.getWhiteLabelAgentList();
  },
    computed: {
        filteredList() {
            return this.agents.filter(agent => {
                return agent.user.first_name.toLowerCase().includes(this.search_fname.toLowerCase())
                    || agent.user.last_name.toLowerCase().includes(this.search_fname.toLowerCase())
                    && agent.user.email.toLowerCase().includes(this.search_email.toLowerCase())
                    && agent.user.username.toLowerCase().includes(this.search_uname.toLowerCase())
                    && agent.api_key==null ? '': agent.api_key.toLowerCase().includes(this.search_key.toLowerCase())

            })
        }
    },

    methods: {
      onClose(){
          this.visible=false;
      },
        searchFilterFunc2(val) {
            this.search=val;
        },
        async userStatusWarning(uuid) {
            var _this = this;
            try {
                this.$swal({
                    title: "Are you sure?",
                    text: "You can't revert your action",
                    type: "error",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Change status!",
                    cancelButtonText: "No",
                    showCloseButton: true,
                    showLoaderOnConfirm: true,
                }).then((result) => {
                    if (result.value) {
                        _this.changeStatus(uuid);
                    } else {
                        this.$swal("Cancelled", "", "info");
                    }
                });
            } catch (err) {
                console.log(err);
            }
        },
      async changeStatus(uuid){
          try{
              axios
                  .post("/api/agent/white-label/status/", {
                      uuid:uuid,
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.getWhiteLabelAgentList();
                          this.$swal("Good job!", "status changed", "success");


                      }else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    async deleteWarning(agent) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(agent);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async getWhiteLabelAgentList() {
      try {
        axios
          .get("/api/agent/white-label/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.agents = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },

    deleteItem: function deleteItem(agent) {
      var _this = this;
      axios
        .post("/api/agent/delete/" + agent.uuid, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
            if(response.data.status){
                _this.getAgentList();
                _this.hasDeleted = false;
            } else {
                var str = response.data.message;
                var jsonParse = JSON.parse(str);
                _this.errorCheck(jsonParse);
            }
        });
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>UserName</th>
                    <th>Name</th>
                    <th>Email</th>
                      <th>Api Key</th>
                    <th>Action</th>
                  </tr>
                  <tr>
                      <td> &nbsp </td>
                      <td><input type="text" class="app-search form-control" v-model="search_uname" placeholder="Search " /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_fname" placeholder="Search " /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_email" placeholder="Search email" /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_key" placeholder="Search api key" /></td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(agent,index) in agents"  v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                      <td v-if="agent.user.username!=null">
                          <div class="row">
                              <div class="col-xs-4">{{agent.user.username}}</div>
                          </div>
                          <div class="row">
                              <div v-if="agent.is_active=='1'" class="col-xs-4">Active</div>
                              <div v-else class="col-xs-4">Deactivated</div>
                          </div>
                      </td>
                      <td v-else >null</td>
                    <td>{{agent.user.first_name}} {{agent.user.last_name}}</td>
                    <td>{{agent.user.email}}</td>
                        <td>{{agent.api_key}}</td>
                    <td><span><button v-if="agent.is_active=='1'" class="btn btn-primary btn-small" @click.prevent="userStatusWarning(agent.user.uuid)">Deactivate</button><button v-else class="btn btn-primary btn-small" @click.prevent="userStatusWarning(agent.user.uuid)">Activate</button></span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
table>tr>td{
    width:30%;
    height:30px;
}
.margin-5px{
    margin-right: 5px;
}
.width-20px{
    width: 20px;
}
.padding-5px{
    padding-right: 3%;
    padding-left: 3%;
}
table>tr>td:nth-child(odd) {
    font-weight: 600;
}
</style>
